import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MedIconsModule } from "@mk/med-icons";

import { MedWarshipBannerComponent } from "./med-warship-banner.component";
import { MedBtnModule } from "../../med-btn/med-btn.module";

@NgModule({
  declarations: [
    MedWarshipBannerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MedBtnModule,
    MedIconsModule,
  ],
  exports: [
    MedWarshipBannerComponent,
  ],
})
export class MedWarshipBannerModule { }
